import type { ComponentMultiStyleConfig } from "@chakra-ui/react";

const parts = ["wrapper", "navigation", "page", "header", "actions", "content"];

const appLayout: ComponentMultiStyleConfig = {
  parts,
  baseStyle: {
    wrapper: {
      width: "100vw",
      height: "100vh",
      display: "grid",
      gridTemplateAreas: '"navigation page"',
      gridTemplateColumns: "auto 1fr",
      gridTemplateRows: "100vh",
      overflow: "hidden"
    },
    navigation: {
      gridArea: "navigation",
      color: "white",
      display: "flex",
      flexFlow: "column nowrap",
      justifyContent: "space-between",
      alignItems: "flex-start",
      paddingTop: 10,
      paddingRight: 4,
      paddingBottom: 10,
      paddingLeft: 4,
      zIndex: 1,
      width: "auto",
      flexShrink: 1
    },
    navigationBottomPanel: {
      width: "fit-content"
    },
    page: {
      gridArea: "page",
      position: "relative",
      width: "100%",
      height: "100vh",
      display: "grid",
      gridTemplateColumns: "60% 40%",
      gridTemplateRows: "max-content auto",
      overflowX: "hidden",
      overflowY: "scroll"
    },
    header: {
      padding: 1
    },
    actions: {
      gridColumn: "1 / 3",
      gridRow: "1",
      display: "flex",
      flexFlow: "row nowrap",
      justifyContent: "flex-end",
      alignItems: "flex-start"
    },
    content: {
      backgroundColor: "#f7f7f7",
      gridColumn: "1 / 3",
      gridRow: "2",
      borderTopLeftRadius: 8, // DO NOT CHANGE
      overflowY: "scroll"
    }
  }
};

export default appLayout;
